export default "__VITE_ASSET__BcOf9g$m__";